(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AudioSearch', AudioSearch);

    AudioSearch.$inject = ['$resource'];

    function AudioSearch($resource) {
        var resourceUrl =  'api/_search/audio/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
